/* CHRONO19 — app.js  (réplique JS des prototypes + cart drawer AJAX) */
(function(){
  'use strict';
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Navbar scroll ---------- */
  var nav = document.getElementById('navbar');
  if (nav) addEventListener('scroll', function(){ nav.classList.toggle('scrolled', scrollY > 40); }, {passive:true});

  /* ---------- Reveals en cascade ---------- */
  function initReveals(){
    var reveals = [].slice.call(document.querySelectorAll('.reveal:not(.visible)'));
    if (reduced){ reveals.forEach(function(el){ el.classList.add('visible'); }); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){
          var group = e.target.closest('section,header,main,nav,.trust,footer') || document.body;
          var sibs = [].slice.call(group.querySelectorAll('.reveal:not(.visible)'));
          var idx = sibs.indexOf(e.target);
          setTimeout(function(){ e.target.classList.add('visible'); }, Math.max(idx,0)*90);
          io.unobserve(e.target);
        }
      });
    }, {threshold:0.12});
    reveals.forEach(function(el){ io.observe(el); });
  }
  initReveals();

  /* ---------- Bande réassurance : marquee continu sans couture ----------
     Clone le groupe pour que la piste fasse >= 2x le conteneur, anime par
     translateX(-Wpx) (W = largeur exacte d'UN groupe), vitesse constante px/s. */
  function initMarquee(){
    var track = document.querySelector('.trust-track');
    var trust = document.querySelector('.trust');
    if (!track || !trust) return;
    if (reduced){ track.style.removeProperty('--marquee-w'); track.style.animationDuration = ''; return; } // statique (CSS)
    var groups = track.querySelectorAll('.trust-group');
    if (!groups.length) return;
    var template = groups[0];
    // repartir d'un seul groupe (idempotent au resize)
    for (var i = groups.length - 1; i >= 1; i--) track.removeChild(groups[i]);
    var groupW = template.getBoundingClientRect().width;
    if (!groupW) return;
    var containerW = trust.getBoundingClientRect().width;
    // piste >= 2x conteneur, minimum 2 copies (davantage sur grand écran)
    var copies = Math.max(2, Math.ceil((containerW * 2) / groupW));
    for (var c = 1; c < copies; c++){
      var clone = template.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    }
    // vitesse constante px/s -> durée = W / vitesse (W = largeur EXACTE d'un groupe)
    var speed = window.innerWidth < 768 ? 80 : 60;
    track.style.setProperty('--marquee-w', groupW + 'px');
    // redémarre l'animation proprement (évite tout saut quand W/durée changent)
    track.style.animation = 'none';
    void track.offsetWidth;
    track.style.animation = '';
    track.style.animationDuration = (groupW / speed) + 's';
  }
  initMarquee();
  // re-mesure une fois les polices swappées (font-display:swap) : sinon W mesuré en police de repli
  // à froid → couture décalée. initMarquee est idempotent (retire ses clones avant de recloner).
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(initMarquee);
  var marqueeTO;
  addEventListener('resize', function(){ clearTimeout(marqueeTO); marqueeTO = setTimeout(initMarquee, 200); }, {passive:true});

  /* ---------- PDP : galerie ---------- */
  var mainImg = document.getElementById('mainImg');
  function swapMain(src){
    if (!mainImg || mainImg.getAttribute('src') === src) return;
    mainImg.classList.add('switching');
    setTimeout(function(){ mainImg.setAttribute('src', src); mainImg.classList.remove('switching'); }, 170);
  }
  var thumbs = [].slice.call(document.querySelectorAll('.thumb'));
  thumbs.forEach(function(t){
    t.addEventListener('click', function(){
      thumbs.forEach(function(x){ x.classList.remove('active'); });
      t.classList.add('active');
      swapMain(t.dataset.src);
    });
  });

  /* ---------- PDP : variantes (Night bascule la galerie + variant id) ---------- */
  var buyForm = document.querySelector('[data-buy-form]');
  var variantButtons = [].slice.call(document.querySelectorAll('.variant'));
  variantButtons.forEach(function(v){
    v.addEventListener('click', function(){
      variantButtons.forEach(function(x){ x.classList.remove('active'); });
      v.classList.add('active');
      if (buyForm) buyForm.dataset.variantId = v.dataset.variantId || '';
      var img = v.dataset.image;
      if (img){
        swapMain(img);
        thumbs.forEach(function(x){ x.classList.remove('active'); });
        if (v.dataset.variant === 'classic' && thumbs[0]) thumbs[0].classList.add('active');
      }
    });
  });

  /* ---------- PDP : quantité ---------- */
  var qv = document.getElementById('qval');
  var qminus = document.getElementById('qminus'), qplus = document.getElementById('qplus');
  if (qminus) qminus.onclick = function(){ qv.value = Math.max(1, (+qv.value||1) - 1); };
  if (qplus) qplus.onclick = function(){ qv.value = Math.min(9, (+qv.value||1) + 1); };

  /* ---------- PDP : accordéons spring ---------- */
  [].slice.call(document.querySelectorAll('.acc')).forEach(function(acc){
    var head = acc.querySelector('.acc-head'), body = acc.querySelector('.acc-body');
    if (acc.classList.contains('open')) body.style.height = body.scrollHeight + 'px';
    head.addEventListener('click', function(){
      var open = acc.classList.contains('open');
      if (open){ body.style.height = body.scrollHeight + 'px'; requestAnimationFrame(function(){ body.style.height = '0px'; }); }
      else { body.style.height = body.scrollHeight + 'px'; }
      acc.classList.toggle('open');
      body.addEventListener('transitionend', function h(){
        if (acc.classList.contains('open')) body.style.height = 'auto';
        body.removeEventListener('transitionend', h);
      });
    });
  });

  /* ================= CART ================= */
  var money = function(cents){ return (cents/100).toFixed(2).replace('.', ',') + ' €'; };
  var drawer = document.getElementById('cartDrawer');
  var overlay = document.getElementById('cartOverlay');

  function openDrawer(){ if(drawer){ drawer.classList.add('open'); overlay.classList.add('open'); drawer.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; var c=document.getElementById('cartClose'); if(c) c.focus(); } }
  function closeDrawer(){ if(drawer){ drawer.classList.remove('open'); overlay.classList.remove('open'); drawer.setAttribute('aria-hidden','true'); document.body.style.overflow=''; } }

  function renderCart(cart){
    var count = cart.item_count;
    [].slice.call(document.querySelectorAll('.nav-count')).forEach(function(b){
      b.textContent = count; b.hidden = count === 0;
    });
    var itemsEl = document.getElementById('cartItems');
    var footEl = document.getElementById('cartFoot');
    if (!itemsEl) return;
    if (!cart.items.length){
      itemsEl.innerHTML = '<div class="cart-empty">Votre panier est vide.</div>';
      if (footEl) footEl.hidden = true;
      return;
    }
    if (footEl) footEl.hidden = false;
    itemsEl.innerHTML = cart.items.map(function(it){
      var opt = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      return '<div class="cart-line" data-key="'+it.key+'">'+
        '<img src="'+(it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/,'_120x$1$2') : '')+'" alt="">'+
        '<div class="cart-line-info">'+
          '<span class="cart-line-name">'+it.product_title+'</span>'+
          (opt ? '<span class="cart-line-opt">'+opt+'</span>' : '')+
          '<div class="cart-line-bottom">'+
            '<div class="cart-qty">'+
              '<button data-act="dec" aria-label="Diminuer">−</button>'+
              '<span>'+it.quantity+'</span>'+
              '<button data-act="inc" aria-label="Augmenter">+</button>'+
            '</div>'+
            '<span class="cart-line-price">'+money(it.final_line_price)+'</span>'+
          '</div>'+
          '<button class="cart-remove" data-act="remove">Retirer</button>'+
        '</div>'+
      '</div>';
    }).join('');
    var sub = document.getElementById('cartSubtotal');
    if (sub) sub.textContent = money(cart.total_price);
  }

  function fetchCart(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}); }
  function changeLine(key, qty){
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(renderCart);
  }
  function addVariant(id, qty){
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:id,quantity:qty||1})}).then(function(r){return r.json();})
      .then(fetchCart).then(function(c){ renderCart(c); openDrawer(); });
  }

  // délégation events drawer
  if (drawer){
    drawer.addEventListener('click', function(e){
      var line = e.target.closest('.cart-line');
      var act = e.target.dataset.act;
      if (act && line){
        var key = line.dataset.key;
        var qspan = line.querySelector('.cart-qty span');
        var q = +qspan.textContent;
        if (act==='inc') changeLine(key, q+1);
        else if (act==='dec') changeLine(key, Math.max(0,q-1));
        else if (act==='remove') changeLine(key, 0);
      }
      if (e.target.dataset.act === 'cross-add'){ addVariant(e.target.dataset.variantId, 1); }
    });
  }
  var closeBtn = document.getElementById('cartClose');
  if (closeBtn) closeBtn.onclick = closeDrawer;
  if (overlay) overlay.onclick = closeDrawer;
  [].slice.call(document.querySelectorAll('[data-cart-toggle]')).forEach(function(b){
    b.addEventListener('click', function(e){ e.preventDefault(); fetchCart().then(function(c){ renderCart(c); openDrawer(); }); });
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeDrawer(); });

  /* ---------- Add to cart (PDP) + sticky bar ---------- */
  function currentVariantId(){ return buyForm ? buyForm.dataset.variantId : null; }
  [].slice.call(document.querySelectorAll('[data-add-cart]')).forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      var id = currentVariantId();
      if (!id) return;
      var qty = qv ? (+qv.value||1) : 1;
      btn.disabled = true;
      addVariant(id, qty).catch(function(){ alert('Ajout impossible.'); }).finally(function(){ btn.disabled = false; });
    });
  });

  // sticky mobile add-to-cart : apparaît quand la colonne d'achat sort du viewport
  var sticky = document.getElementById('stickyAtc');
  var buyCol = document.querySelector('.buy');
  if (sticky && buyCol && 'IntersectionObserver' in window){
    var so = new IntersectionObserver(function(en){
      sticky.classList.toggle('show', !en[0].isIntersecting);
    }, {rootMargin:'-70% 0px 0px 0px'});
    so.observe(buyCol);
  }

  // init compteur au chargement
  fetchCart().then(renderCart).catch(function(){});
})();
